export const defaultStyle = {
    tableResponsive: "tableResponsive",
    tableContainer: "tableWarp",
    tableWarp_thead: "tableWarp_thead",
    thDataWrpr: "thDataWrpr",
    tableWarp_tbody: "tableWarp_tbody",
    tdStyle: "tdStyle",
    tdStyle1: "tdStyle1",
    tableTitle: "tableTitle",
    iconClassWarp: "iconClassWarp",
}

export const TABLE_WITH_IMAGES = {
    tableResponsive: "tableResponsive w-full bg-white lg:mb-[50px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:px-15",
    tableContainer: "tableWarp w-full",
    tableWarp_thead: "tableWarp_thead hidden lg:table-header-group md:table-header-group",
    thStyle: "thStyle text-left md:text-[28px] text-[14px] md:bg-white md:bg-white pb-16 md:p-15 text-black font-MDLZBiteType !font-normal",
    tableWarp_tbody: "tableWarp_tbody",
    tdStyle: "tdStyle bg-grayWhite even:bg-white align-top",
    tableTitle: "tableTitle max-w-xl mx-auto px-[35px] lg:px-15   text-left font-Light text-[24px] md:text-[48px] text-green mb-[35px] md:leading-[57.6px]",
    mobileHeading: "mobileHeading text-left text-[16px] pb-16 md:p-15 text-black font-MDLZBiteType",
    iconClassWarp: "iconClassWarp text-[3em] text-purple text-center",
    tdStyle1: "tdStyle1 [&>div>p>a]:font-bold md:[&>div>p>a]:leading-[31.5px] md:[&>div>p>a]:tracking-[2.2px] hover:[&>div>p>a]:text-orange hover:[&>div>p>a]:border-b-2 hover:[&>div>p>a]:border-solid hover:[&>div>p>a]:no-underline",
}
export const TABLE_WITH_IMAGES_GREEN_HEADING = {
    ...TABLE_WITH_IMAGES,
    thStyle: "thStyle text-green text-left md:text-[48px] text-[24px] md:bg-white md:bg-white pb-16 md:p-15 text-black font-Light !font-normal",
    mobileHeading: "mobileHeading2 text-green text-left !text-[24px] pb-16 md:p-15 font-Light !font-normal",
}
export const TABLE_WITH_MID_IMG= {
    ...TABLE_WITH_IMAGES,
    tableResponsive: "tableResponsive tableMidImg w-full bg-white lg:mb-[50px] max-w-xl mx-auto md:px-15",
}
export const TABLE_WITH_BORDER = {
    tableResponsive: "tableResponsive w-full bg-white mb-30 lg:mb-[50px] max-w-xl mx-auto px-15",
    tableContainer: "!table w-full table-auto border-1 !rounded-none",
    tableWarp_thead: "tableWarp_thead",
    thDataWrpr: "thDataWrpr text-white",
    thStyle: "thStyle !bg-purple text-center md:text-[28px] text-[14px] pb-16 md:p-15 text-white font-MDLZBiteType",
    tableWarp_tbody: "tableWarp_tbody box-border",
    tdStyle: "tdStyle",
    tdStyle1: "tdStyle1 p-[15px] border-1 text-center",
    tableTitle: "tableTitle max-w-xl mx-auto px-[35px] lg:px-15   text-left font-Light text-[24px] md:text-[48px] text-green mb-[35px] md:leading-[57.6px]",
    mobileHeading: "mobileHeading text-left text-[16px] pb-16 md:p-15 text-black font-MDLZBiteType hidden"
}
export const TABLE_WITH_BORDER_BGCOLOR = {
    ...TABLE_WITH_BORDER,
    tableResponsive: "tableResponsive w-full bg-white mb-30 lg:mb-[50px] max-w-xl mx-auto px-15",
    thStyle: "thStyle !bg-purple text-center md:text-[28px] text-[14px] pb-16 md:p-15 text-white font-MDLZBiteType border-r-1",
    tdStyle: "tdStyle bg-grayWhite even:bg-white border-1",
    tdStyle1: "tdStyle2 px-15 py-15 text-left font-21 [&>div>p]:mb-20 [&>div>ul]:ml-20 border-r-1 [&>div>ul>li]:list-disc"
}

export const CLIMATE_PAGE_TABLE = {
    ...TABLE_WITH_IMAGES,
    tableTitle: "tableTitle max-w-xl mx-auto px-[35px] lg:px-15 capitalize text-left font-Light text-[24px] md:text-[24px] text-green mb-[35px] md:leading-[57.6px]",
    tableWrpr: "tableWrapper mb-[50px] md:px-[15px] lg:max-w-lg xl:max-w-xl mx-auto",
    tableContainer: "tableWarp tableWarpClimate bg-white lg:mb-[50px] lg:max-w-lg xl:max-w-xl w-full px-[50px] table-fixed",
    thStyle: "thStyle text-left md:text-[28px] text-[14px] md:bg-white md:bg-white md:py-[15px] text-black font-MDLZBiteType tracking-normal font-normal align-bottom",
    tablePara: "tablePara",
    tableWarp_tbody: "tableWarp_tbody box-border",
    mobileHeading: "mobileHeading text-left text-[16px] pb-16 md:p-15 text-black font-MDLZBiteType"
}

export const PACKAGING_PLASTICS_MULTI_ROW = {
    tableResponsive: "tableResponsive w-full bg-white lg:mb-[50px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:px-15",
    tableWrpr: "tableWrprTop",
    tableContainer: "tableWarp w-full",
    //tableContainer: "tableWarp tableWarpPlastic bg-white lg:mb-[50px] md:max-w-md w-full lg:max-w-lg xl:max-w-xl mx-auto px-[15px]",
    tableWarp_thead: "tableWarp_thead hidden lg:table-header-group md:table-header-group",
    thStyle: "thStyle font-[400] text-left md:text-[28px] font-normal text-[14px] md:bg-white md:bg-white pb-16 p-15 pl-[0] pr-[30px] text-black font-MDLZBiteType",
    tableWarp_tbody: "tableWarp_tbody",
    tdStyle: "tdStyle bg-grayWhite even:bg-white md:[&>td]:!pl-0 md:[&>td]:!pr-[30px]",
    tableTitle: "tableTitle xl:max-w-xl md:max-w-md lg:max-w-lg mx-auto capitalize text-left font-Light text-[24px] md:text-[48px] text-green mb-[45px] md:leading-[72px] px-[35px] md:px-[15px]",
    mobileHeading: "mobileHeading text-left text-[16px] font-normal tracking-[normal] leading-[24px]  mb-[15px] md:p-15 text-black font-MDLZBiteType"
}

export const TABLE_WITH_SECTION = {
    tableWrpr: " md:max-w-md lg:max-w-lg xl:max-w-xl md:px-[15px] px-[35px] mx-auto pb-[50px] pt-[30px]",
    tableContainer: "tabelSeCont",
    tableWarp_thead: "tableWarp_thead",
    thDataWrpr: "thDataWrpr [&>th]:text-left [&>th]:text-[20px] font-MDLZBiteType [&>th]:py-[15px] [&>th]:leading-[30px] [&>th]:tracking-normal [&>th]:font-normal",
    tableWarp_tbody: "tableWarp_tbody",
    tdStyDIV: "tdStyDIV table-row bg-[#e0dae6] [&>p]:text-[14px] [&>p]:tracking-[0.53] [&>p]:uppercase [&>p]:font-Bold [&>p]:p-[5px] [&>p]:leading-[21px] [&>p]:min-h-[31px]",
    tdStyle: "tdStyle ",
    tableTitle: "tableTitle",
}

export const SIMPLE_TABLE = {
    ...TABLE_WITH_IMAGES,
    thStyle: "thStyle text-left md:text-[16px] text-[14px] md:bg-white md:bg-white pb-16 md:p-15 text-black font-MDLZBiteType font-normal tracking-normal",
    tdStyle: "tdStyle bg-grayWhite even:bg-white text-[14px]",
}

export const SIMPLE_TABLE_THAI = {
    ...SIMPLE_TABLE,
    thStyle: "testing font-[700] thStyle text-left md:text-[16px] text-[14px] md:bg-white md:bg-white pb-16 md:p-15 text-black font-MDLZBiteType font-normal tracking-normal",
}

export const TABLE_WITHIN_CONTAINER = {
    ...TABLE_WITH_IMAGES,
    tableResponsive: "tableResponsive w-full bg-white mb-30 lg:mb-[50px] max-w-xl mx-auto px-15 overflow-x-scroll md:overflow-hidden",
    tableContainer: "tableWarpWithinContainer bg-white lg:mb-[50px] max-w-xl mx-auto px-[35px] lg:px-[0px] lg:mx-15",
    thStyle: "thStyle text-left md:text-[16px] text-[14px] md:bg-white md:bg-white pb-16 md:p-15 text-black font-MDLZBiteType font-normal tracking-normal",
    tdStyle: "tdStyle bg-grayWhite even:bg-white text-[14px]",
    tdStyle1: "tdStyle1 px-15 py-15"
}



export const TABLE_WITHIN_CONTAINER_TITLE_BIG = {
    ...TABLE_WITHIN_CONTAINER,
    thStyle: "thStyle text-left md:text-[28px] text-[16px] md:bg-white md:bg-white pb-16 md:p-15 text-black font-MDLZBiteType font-normal tracking-normal",
    tdStyle: "tdStyle bg-grayWhite even:bg-white text-[21px] align-top",
}
export const TABLE_WITH_NEWS = {
    ...TABLE_WITHIN_CONTAINER,
    tableResponsive: "tableResponsive w-full bg-white lg:mb-[50px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:px-[15px] ",
    tableContainer: "tableWarpWithinContainer tableWarpIntheNews bg-white lg:mb-[50px] max-w-xl mx-auto px-[35px] lg:px-[0px] lg:mx-15 flex flex-col",
    tablePara: "tablePara text-[21px]",
    tableWarp_thead: "tableWarp_thead hidden lg:table-header-group md:table-header-group [&>tr]:flex [&>tr]:w-full [&>tr>th]:w-[33.33%] [&>tr>th]:pl-[15px] ",
    mobileHeading: "mobileHeading text-left text-[16px] pb-16 md:p-15 text-black font-MDLZBiteType",
    thStyle: "thStyle text-left md:text-[28px] text-[14px] md:bg-white md:bg-white py-[15px] pr-[30px] text-black font-MDLZBiteType font-normal",
    tdStyle: "tdStyle IntheNewsWrapper bg-grayWhite even:bg-white text-[14px] w-full flex flex-wrap",
    tdStyle1: "tdStyle1 px-[35px] lg:!pr-[30px] pt-[15px] pb-[15px] last:pb-[30px] md:py-[45px] text-center md:text-left md:pl-[0px] md:w-[31%] max-md:block !w-full md:!w-[33.33%]",
}

export const TABLE_WITH_YEAR = {
    ...CLIMATE_PAGE_TABLE,
    tableTitle: "tableTitle max-w-xl mx-auto md:px-[30px] px-[15px] capitalize text-left font-Light text-[24px] md:text-[48px] text-green mb-[35px] md:leading-[57.6px]",
    tableWrpr: "tableWrapper mb-[50px] md:px-[35px] lg:px-[60px] max-[1300px]:overflow-x-hidden w-full md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
    tableWarp_thead: "tableWarp_thead hidden lg:table-header-group md:table-header-group",
    thStyle: "thStyle text-left md:text-[28px] text-[14px] md:bg-white md:bg-white md:py-[15px] md:px-[15px] text-black font-MDLZBiteType tracking-normal font-normal pr-[30px]",
    mobileHeading: "mobileHeading font-MDLZBiteType text-left text-[16px] block tracking-[0.35px] pb-16  md:p-15 text-black font-MDLZBiteType w-100%",
    tdStyle1: "W650 !py-[5px] ",
    tableContainer: "tableWarpClimate w-full tableWarpOne ",

}
export const TABLE_WITH_PERSONAL_DATA = {
    ...TABLE_WITH_IMAGES,
    tableTitle: "tableTitle max-w-xl mx-auto px-[35px] lg:px-15 capitalize text-left font-Light text-[24px] md:text-[24px] text-green mb-[35px] md:leading-[57.6px]",
    tableWrpr: "tableWrapper mb-[50px] md:px-[15px] lg:max-w-lg xl:max-w-xl mx-auto",
    tableContainer: "tableWarpClimate bg-white lg:mb-[50px] lg:max-w-lg xl:max-w-xl w-full px-[50px] table-fixed",
    thStyle: "thStyle text-left md:text-[28px] text-[14px] md:bg-white md:bg-white md:py-[15px] text-black font-MDLZBiteType tracking-normal font-normal align-bottom",
    tablePara: "tablePara",
    tableWarp_tbody: "tableWarp_tbody box-border",
    mobileHeading: "mobileHeading text-left text-[16px] pb-16 md:p-15 text-black font-MDLZBiteType"
}
export const TABLE_WITH_BORDER_TEXT_LEFT = {
    ...TABLE_WITH_BORDER,
    tdStyle1: "tdStyle1 [&>div] px-[7.200px] border-1 text-left [&>div>p>a]:text-purple [&>div>p>a]:font-bold [&>div>p>a]:leading-[21px] md:[&>div>p>a]:leading-[31.5px] [&>div>p>a]:tracking-[0.53px] md:[&>div>p>a]:tracking-[2.2px] [&>div>p>a]:text-[14px] md:[&>div>p>a]:text-[21px] [&>div>p]:mb-[10px] [&>div>ul>li]:ml-[20px] [&>div>ul>li]:text-[18px] [&>div>ul>li]:font-['Times_New_Roman'] [&>div>ul]:px-[15px] [&>div>ul>li]:list-disc [&>div>p]:text-[18px] [&>div>p]:px-[20px] md:[&>div>p]:px-[20px] lg:[&>div>p]:px-[0px] [&>div>p]:font-['Times_New_Roman'] hover:[&>div>p>a]:text-orange hover:[&>div>p>a]:border-b-2 hover:[&>div>p>a]:border-solid hover:[&>div>p>a]:no-underline [&>div>ul>li>a]:font-Regular md:[&>div>ul>li>a]:tracking-[2.2px] md:[&>div>ul>li>a]:leading-[31.5px] md:[&>div>ul>li>a]:text-[21px] [&>div>ul>li>a]:font-bold hover:[&>div>ul>li>a]:text-orange hover:[&>div>ul>li>a]:border-b-2 hover:[&>div>ul>li>a]:border-solid hover:[&>div>ul>li>a]:no-underline [&>div>ul>li>span>strong>a]:text-[21px] [&>div>ul>li>span>strong>a]:tracking-[2.2px] [&>div>ul>li>span>strong>a]:font-Regular [&>div>ul>li>span>strong>a:hover]:text-orange [&>div>ul>li>span>strong>a:hover]:underline",
    tableContainer: "!table w-full table-auto border-1 !rounded-none",
    tableResponsive: "tableResponsive w-full lg:mb-[50px] bg-white md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[36px] md:px-[62px] lg:px-[31px]",
    mobileHeading: "mobileHeading text-left text-[16px] text-black font-MDLZBiteType",
    tableTitle: "tableTitle max-w-xl mx-auto px-[51px] md:px-[31px] capitalize text-left font-Light text-[24px] md:text-[24px] lg:text-[48px] text-green mb-[35px] leading-[28.8px] md:leading-[28.8px] lg:leading-[57.6px]",
}
export const TABLE_WITH_BORDER_SIMPLE = {
    ...TABLE_WITH_BORDER,
    tableContainer: "!table w-[50%] table-auto border-1 !rounded-none",
    thStyle: "thStyle text-left border-1 bg-[#ffffcc] md:text-[21px] text-[12px] pb-16 md:p-10 text-black",
    tdStyle1: "tdStyle1 text-left md:p-10 border-1 [&>div>p>a]:text-purple [&>div>p]:mb-[10px] align-top"
}

export const TABLE_WITH_BORDER_SMALL_FONT = {
    ...TABLE_WITH_BORDER_SIMPLE,
    tableResponsive: "tableResponsive w-full bg-white md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[20px] md:px-[62px] lg:px-[31px]",
    thStyle: "thStyle text-left border-1 bg-[#ffffcc] md:text-[18px] text-[18px] md:p-10 text-black px-[20px] w-1/2",
    tdStyle1: "tdStyle1 text-left border-1 [&>div>p]:text-[18px] [&>div>p>a]:text-purple [&>div>p]:mb-[10px] align-top lg:[&>div>p]:px-[7.200px] md:[&>div>p]:px-[27.200px] [&>div>p]:px-[27.200px] w-1/2",
    tableContainer: "!table table-auto border-1 !rounded-none lg:w-1/2 md:w-full w-full",
}

export const dynamiTableStyles = {
    tableResponsive: "tableResponsive",
    tableContainer: "tableWarp",
    tableWarp_thead: "tableWarp_thead",
    thDataWrpr: "thDataWrpr",
    tableWarp_tbody: "tableWarp_tbody",
    tdStyle: "tdStyle",
    tdStyle1: "tdStyle1",
    tableTitle: "tableTitle",
    iconClassWarp: "iconClassWarp",
}

export const MULTI_ROW_TABLE_WITH_ICON = {
    ...TABLE_WITH_IMAGES,
}

export const TABLE_WITH_IMAGES_LINK_BLUE = {
    tableResponsive: "tableResponsive w-full bg-white lg:mb-[50px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:px-15",
    tableContainer: "tableWarp w-full",
    tableWarp_thead: "tableWarp_thead hidden lg:table-header-group md:table-header-group",
    thStyle: "thStyle text-left md:text-[28px] text-[14px] md:bg-white md:bg-white pb-16 md:p-15 text-black font-MDLZBiteType !font-normal",
    tableWarp_tbody: "tableWarp_tbody",
    tdStyle: "tdStyle bg-grayWhite even:bg-white align-top",
    tableTitle: "tableTitle max-w-xl mx-auto px-[35px] lg:px-15   text-left font-Light text-[24px] md:text-[48px] text-green mb-[35px] md:leading-[57.6px]",
    mobileHeading: "mobileHeading text-left text-[16px] pb-16 md:p-15 text-black font-MDLZBiteType",
    iconClassWarp: "iconClassWarp text-[3em] text-purple text-center",
    tdStyle1: "tdStyle1 [&>div>p>a]:font-bold md:[&>div>p>a]:leading-[31.5px] md:[&>div>p>a]:tracking-[2.2px] hover:[&>div>p>a]:text-orange hover:[&>div>p>a]:border-b-2 hover:[&>div>p>a]:border-solid hover:[&>div>p>a]:no-underline [&>a]:text-purple [&>a]:font-bold [&>a]:tracking-[2.2px] [&>a:hover]:underline",
}